import { Component, OnInit } from '@angular/core';
import { PrivacyService } from '../privacy/privacy.service';
import { constants } from '../constants';

@Component({
  selector: 'app-form-personal-data',
  templateUrl: './form-personal-data.component.html',
  styleUrls: []
})
export class FormPersonalDataComponent implements OnInit {

  textLODP:string = ""
  modalTitle:string = ""
  modalContent:string = ""
  linkPolicy:string = ""
  linkCookies:string = ""

  isShowModal:boolean = false

  constructor(private privacyService:PrivacyService) { }

  ngOnInit() {
    this.getLinksDocument()
  }

  getLinksDocument(){

      this.privacyService.getAllPolicy().subscribe(((dataResponse:any) => {
        
        if (dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE) {  
          dataResponse.obj.forEach(element => {
            if (element.policyType.includes("COOKIES")) {
              this.linkCookies = element.documentLink.link
            }
            if (element.policyType.includes("PRIVACIDAD")) {
              this.linkPolicy = element.documentLink.link
            }
          });
        }
        this.getDataTerms()
      }))
  }

  getDataTerms(){
  
    this.privacyService.getGroupParameters("TEXTOS_LOPD").subscribe(((dataResponse:any) => {
      if(dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){

        this.textLODP = dataResponse.obj.map(element => {
          return  {   "name": element.name, 
                      "value": element.value
                              .replace("Ejercicio de Derechos", `<a class="a-link" href="#/form-privacy"><strong>Ejercicio de Derechos </strong></a>`) 
                              .replace("Política de Privacidad",`<a class="a-link" href='${this.linkPolicy}' target="_blank"><strong>Política de Privacidad</strong></a>`) 
                              .replace("Política de Cookies",  ` <a class="a-link" href='${this.linkCookies}'target="_blank"><strong> Política de Cookies  </strong></a>`) 
                  }
        });
      }
    }),
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    });
  }

  
  hideModal() {
    this.isShowModal = false;
  }
}
